<template>
  <span class="brand" role="img" aria-label="SIMA">
    <span class="brand__star" :style="starStyle"></span>
    <span v-if="wordmark" class="brand__word"></span>
  </span>
</template>

<script>
// SIMA-Logo oben in der Navigation wie im Kopf von simasoftware.de: der SIMA-Stern in Orange (--acc) und daneben der
// Schriftzug „SIMA“ in der Markenschrift (74 × 16, eingefärbt in --ink, 8 px Abstand zum Stern). Beide kommen als Masken
// aus den Vektordateien der Website (public/img/sima-logo-icon.svg, sima-logo-text.svg), die Farben aus den Tokens.
// size: Kantenlänge des Sterns (Seitenleiste und Rail 22, Touch-Rail 28); wordmark: Schriftzug anzeigen.
export default {
  name: 'AppBrandMark',
  props: {
    size: { type: Number, default: 28 },
    wordmark: { type: Boolean, default: false }
  },
  computed: {
    starStyle() {
      return { width: this.size + 'px', height: this.size + 'px' };
    }
  }
};
</script>

<style scoped>
.brand {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.brand__star,
.brand__word {
  flex: none;
  display: block;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
}
.brand__star {
  background: var(--acc);
  -webkit-mask-image: url('/img/sima-logo-icon.svg');
  mask-image: url('/img/sima-logo-icon.svg');
}
.brand__word {
  width: 74px;
  height: 16px;
  background: var(--ink);
  -webkit-mask-image: url('/img/sima-logo-text.svg');
  mask-image: url('/img/sima-logo-text.svg');
}
</style>
